<!--This Component is for the syncing status on Header Nav in Home dashboard (w/o CloudSync)-->
<template>
	<div
		v-if="sync"
		@click="syncStore.beginSync({ verify: true })"
		class="flex cursor-pointer flex-row items-center"
	>
		<ArrowPathIcon
			class="fill-secondary-600 mr-1 size-3"
			:class="syncStore.syncing ? 'animate-spin' : ''"
		/>
		<div
			class="text-secondary-400 text-[10px] font-normal tracking-wide"
			data-test-id="sync-updated-date"
		>
			<span
				class="uppercase"
				v-if="syncStore.syncing"
			>
				{{ t('home.syncing') }}
				<span
					v-if="syncStore.percentComplete && syncStore.percentComplete < 100"
					>{{ syncStore.percentComplete }}%</span
				>
			</span>
			<span
				v-else-if="crmStore.appointments?.downloadedAt"
				:title="t('home.sync', { date: updatedDate })"
			>
				<span class="mr-1 uppercase">{{ t('home.lastUpdated') }}</span>
				<span class="lowercase">{{ updatedDate }}</span>
			</span>
			<span v-else> {{ t('home.lastUpdatedNever') }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useCrmStore } from '@/stores/crm'
import { useSyncStore } from '@/stores/sync'
import { ArrowPathIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
	sync: Boolean,
})

const { d, t } = useI18n()

const syncStore = useSyncStore()
const crmStore = useCrmStore()

/** Last updated date */
const updatedDate = computed(() => {
	if (!crmStore.appointments?.downloadedAt) return ''
	let now = new Date()
	let date = new Date(crmStore.appointments?.downloadedAt)
	if (date.toDateString() === now.toDateString()) {
		return d(date, 'time')
	} else {
		return d(date, 'shortDate')
	}
})
</script>

<style scoped></style>
